import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE from "../config/api";

export default function MyListings({ onUpgrade }) {
    const navigate = useNavigate();
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);

    const userData = JSON.parse(localStorage.getItem("user"));
    const user_id = userData?.personaluid;

    useEffect(() => {
        if (!user_id) {
            setLoading(false);
            return;
        }

        fetch(`${API_BASE}/api/get_user_listings.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ user_id }),
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) setListings(data.listings);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [user_id]);

    const openListing = (listinguid) => navigate(`/profile?listinguid=${listinguid}`);

    const goTocommandrev = (listinguid) => navigate(`/commentsreviews?listinguid=${listinguid}`);
    useEffect(() => {
        // Initialize tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(
            el => new window.bootstrap.Tooltip(el)
        );

        // Cleanup: Destroy tooltips when component unmounts
        return () => {
            tooltipList.forEach(t => t.dispose());
        };
    }, [listings]);


    // BEAUTIFUL LOADER
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
                <div className="spinner-box text-center">
                    <div className="pulse-loader"></div>
                    <p className="mt-3 text-secondary fw-semibold">Fetching your business listings...</p>
                </div>

                <style>
                    {`
                        .pulse-loader {
                            width: 60px;
                            height: 60px;
                            border-radius: 50%;
                            background: linear-gradient(135deg, #4a90e2, #5fb3ff);
                            animation: pulse 1.2s infinite ease-in-out;
                        }
                        @keyframes pulse {
                            0% { transform: scale(0.85); opacity: 0.7; }
                            50% { transform: scale(1); opacity: 1; }
                            100% { transform: scale(0.85); opacity: 0.7; }
                        }
                    `}
                </style>
            </div>
        );
    }

    return (
        <div className="container-fluid py-4">

            {/* PAGE HEADER */}
            <div
                className="rounded p-3 mb-3 shadow-sm"
                style={{
                    background: "linear-gradient(135deg, #e8f0ff, #fefefe)",
                    borderLeft: "6px solid #4a90e2"
                }}
            >

                <h5 className="fw-bold text-dark mb-1">My Listed Businesses</h5>
                <p className="text-secondary mb-0">
                    View, manage and upgrade your business listings.
                </p>
            </div>

            {/* NO LISTINGS MESSAGE */}
            {listings.length === 0 ? (
                <div className="alert alert-info shadow-sm p-3 fs-5 text-center">
                    You have not listed any business yet.
                </div>
            ) : (
                <div className="table-responsive shadow rounded">
                    <table className="table table-hover align-middle mb-0">
                        <thead
                            style={{
                                background: "#f2f6ff",
                                borderBottom: "2px solid #dbe5ff"
                            }}
                        >
                            <tr>
                                <th>#</th>
                                <th>Business</th>
                                <th>Location</th>
                                <th>Contact</th>
                                <th>Created</th>
                                <th>Status</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {listings.map((item, index) => (
                                <tr key={item.id} className="listing-row">
                                    <td className="fw-bold text-primary">{index + 1}</td>

                                    <td>
                                        <h6 className="fw-semibold text-dark mb-1">{item.title}</h6>
                                        <small className="text-muted">{item.email}</small>
                                    </td>

                                    <td>
                                        <span className="text-muted">📍 {item.province}, {item.district}</span>
                                    </td>

                                    <td className="text-muted">
                                        📞 {item.mobile}
                                    </td>

                                    <td className="text-muted small">
                                        {item.created_at}
                                    </td>
                                    <td>
                                        {item.states == 1 ? (
                                            <span className="badge bg-success">Approved</span>
                                        ) : (
                                            <span className="badge bg-warning text-dark">Pending</span>
                                        )}
                                    </td>

                                    <td className="text-center">
                                        <div className="d-flex justify-content-center gap-3">

                                            {/* 👁 View */}
                                            <i
                                                className="bi bi-eye-fill text-primary fs-5 action-icon"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="View Listing"
                                                onClick={() => openListing(item.listinguid)}
                                                style={{ cursor: "pointer" }}
                                            ></i>

                                            {/* ⭐ Upgrade */}
                                            <i
                                                className="bi bi-star-fill text-warning fs-5 action-icon"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Upgrade to Premium"
                                                onClick={() => onUpgrade(item.listinguid)}
                                                style={{ cursor: "pointer" }}
                                            ></i>

                                            {/* 💬 Comments & Reviews */}
                                            <i
                                                className="bi bi-chat-left-text-fill text-success fs-5 action-icon"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Comments & Reviews"
                                                onClick={() => goTocommandrev(item.listinguid)}
                                                style={{ cursor: "pointer" }}
                                            ></i>

                                        </div>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* ROW HOVER EFFECT */}
            <style>
                {`
                    .listing-row:hover {
                        background: #f7faff !important;
                        cursor: pointer;
                        transition: 0.2s ease-in-out;
                    }

                    table {
                        border-radius: 12px !important;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
